import { FC, ReactElement, useEffect } from 'react';

import { useYandexMetric } from '../../hooks/useYandexMetric';

type Props = {
	goal: string;
	eventLabel?: string | number;
	children?: ReactElement;
};

const ReachGoalOnMount: FC<Props> = ({ goal, eventLabel = 'null', children }) => {
	const { trackYM } = useYandexMetric();

	useEffect(() => {
		trackYM(goal, String(eventLabel));
	}, [eventLabel, goal, trackYM]);

	return children || null;
};

export default ReachGoalOnMount;
